import React, { Component } from "react";
import Dashboard from "components/Dashboard";
import Auth from "Api/Auth";
import UnauthenticatedApp from "components/UnauthorizedComponents/UnauthenticatedApp";
import { Router } from "@reach/router";
import { LoadPanel } from "devextreme-react";
import { connect } from "react-redux";
function mapStateToProps(state) {
  return {
    isAuthenticated: state.isAuthenticated,
    loading: state.loading,
    loadMessage: state.loadMessage,
  };
}
class Landing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuthenticated: false,
    };
  }
  componentDidMount() {
    this.setState({ isAuthenticated: Auth.isAuthenticated() });
  }

  static getDerivedStateFromProps(props, state) {
    if (props.isAuthenticated !== state.isAuthenticated) {
      return {
        isAuthenticated: Auth.isAuthenticated(),
      };
    }
    return null;
  }

  render() {
    return (
      <div>
        {this.state.isAuthenticated ? (
          <Router>
            <Dashboard path="/*" />
          </Router>
        ) : (
          <UnauthenticatedApp />
        )}
        <LoadPanel
          visible={this.props.loading}
          message={this.props.loadMessage}
          shading={true}
          shadingColor={"rgba(0, 0, 0, 0.2)"}
        />
      </div>
    );
  }
}
export default connect(mapStateToProps)(Landing);
